module.exports = __webpack_public_path__ + "03c2c795773ff9bf789419e42e158020.svg";